import React from 'react'
import { Text, Button, Box } from "grommet"
import {
    Home,
    Dashboard,
    Services,
    Run,
    DocumentConfig,
    Code,
    Analytics,
    SettingsOption,
    Database,
    Notification,
    Group,
    Test,
    Connect,
    FingerPrint,
    Info,
    Apps,
    LineChart,
    View,
    Troubleshoot,
    Alarm,
    Bitcoin,
    Cube,
    DocumentStore,
    Risk,
    Connectivity,
    Network,
    Deploy,
    Phone,
    History,
    Organization,
    List,
    ServicePlay
} from "grommet-icons"
import { Link, useLocation } from "react-router-dom"

import { ListItem } from './List'

const LayoutListItem = ({ itemText, itemIcon, itemLink, sideBarSelected, handleClickSidebar }) => {

    const sideBarValue = itemLink.split('/')[1]
    let location = useLocation();

    const iconComponents = {
        home: Home,
        icinga: ServicePlay,
        health: Dashboard,
        observability: View,
        session: Group,
        data: Database,
        suggest: Info,
        component: Apps,
        connect: Connect,
        inventory: Database,
        services: Services,
        runner: Run,
        config: DocumentConfig,
        code: Code,
        reports: Analytics,
        settings: SettingsOption,
        test: Test,
        admin: FingerPrint,
        market: LineChart,
        watcher: View,
        triage: Troubleshoot,
        alert: Alarm,
        price: Bitcoin,
        product: Cube,
        cassandra: DocumentStore,
        bouncer: Risk,
        ttus: Connectivity,
        fix: Network,
        orders: Deploy,
        pager: Phone,
        history: History,
        notification: Notification,
        bankalgo: Organization,
        actions: Run,
        versions: List,
        smoketest: Test
    }

    const ItemIconComponent = iconComponents[itemIcon]

    return (
        <ListItem
            background={sideBarValue === sideBarSelected ? 'light-1' : 'light-3'}
            pad="3px"
        >
            <Link to={{pathname:itemLink, search:location.search}} onClick={handleClickSidebar}>
                <Button
                    fill
                    plain
                    margin={{ left: "xsmall" }}
                    alignSelf="center"
                >
                    <Box alignSelf="center" alignContent="center" direction="row">
                        <Box alignSelf="center">
                            <ItemIconComponent size="13px" color={sideBarValue === sideBarSelected ? 'brand' : 'dark-4'} />
                        </Box>
                        <Text margin={{ left: "small" }} size="14px" weight="bold" color={sideBarValue === sideBarSelected ? 'brand' : 'dark-3'}>
                            {itemText}
                        </Text>
                    </Box>
                </Button>
            </Link>
        </ListItem >
    )
}

export default LayoutListItem
